import { pipeProviders } from './helpers'

type Providers = 'mui' | 'styled' | 'antd'

type ProviderAPI = {
	withProvider: (Comp: React.ComponentType) => (props: any) => JSX.Element
}
type ProviderAPISSR = ProviderAPI & { extractCss: (groupedHtml: string) => string }

// TODO: split type to client and server so each will be able to load only the relevant provider apis
// (client dont need styleExtractor)
export type ProviderFactories = { [key in Providers]: () => ProviderAPISSR }

export const uiContextProviders = <T extends Providers>(
	providers: Array<T>,
	providerApiFactories: { [key in T]: () => ProviderAPISSR }
) => {
	const createProviderApis = () => providers.map((provider) => providerApiFactories[provider]())
	const providerApis = createProviderApis()

	const wrapProviders = (comp: React.ComponentType<any>): React.ComponentType<any> => {
		const contexts = providerApis.map(({ withProvider }) => withProvider)
		const applyProviders = pipeProviders<React.ComponentType<any>>(...contexts)
		const WrappedComponent = applyProviders(comp)
		return WrappedComponent
	}
	const styleExtractor = (groupedHtml: string) =>
		providerApis.map(({ extractCss }) => extractCss(groupedHtml)).join('')

	return {
		wrapProviders,
		styleExtractor,
	}
}

export const emotionCacheKey = 'mui-css'
